const mob_nav_btns = document.querySelectorAll('.mob-division-button');
const mob_nav_back_btns = document.querySelectorAll('.hamburger-nav-redesign-back-button');
const mob_panel_btns = document.querySelectorAll('.js-panel-btn');
const panel_parent_container = document.querySelector('.mob-nav-link-lists');
const mob_menu_btn = document.querySelector('.hamburger-button');
const overlay_bg = document.querySelector('#black-overlay2');
const mob_close_btn = document.querySelector('.mob-close-menu');


mob_menu_btn.addEventListener('click', showMobileMenu)
overlay_bg.addEventListener('click', hideMobileMenu)
mob_close_btn.addEventListener('click', hideMobileMenu)

mob_panel_btns.forEach(btn => {
    btn.addEventListener('click', togglePanel)
})
mob_nav_back_btns.forEach(btn => {
    btn.addEventListener('click', returnMeganav)
})
mob_nav_btns.forEach(btn => {
    btn.addEventListener('click', showMeganav)
})

function showMeganav() {
    var panelClass = this.dataset.nav,
        panel = document.querySelector(`#${panelClass}`),
        mobHeader = document.querySelector('.mob-menu-header'),
        listHeader = document.querySelector('.mob-link_list-header');

        panel.querySelector('.mob-scroll-container-inner').style.height = `calc(100vh - ${mobHeader.offsetHeight + listHeader.offsetHeight}px)`;
        panel.classList.add('panel-active');
        panel_parent_container.classList.add('a-panel-is-active');
}

function returnMeganav() {
    var panelClass = this.dataset.nav,
        panel = document.querySelector(`#${panelClass}`);

        panel.classList.remove('panel-active');
        panel_parent_container.classList.remove('a-panel-is-active');
}
function togglePanel() {
    var panelClass = this.dataset.nav,
        panel = $(this).parent().find(`[${panelClass}]`),
        hidden = $(this).attr('aria-expanded') === 'true' ? true : false,
        self = $(this)

        panel.slideToggle(400, function() {
            self.attr('aria-expanded', `${!hidden}`);
        })
}

function showMobileMenu() {
    $("#main-nav").animate({
        left: 0
    }, 500)
    $("#black-overlay2").fadeIn(500)
    $("body").css("overflow", "hidden")
    $("html").css("overflow", "hidden")
}

function hideMobileMenu() {
    // var wdth = Math.abs(parseFloat(a(".nav-container").width()));
    $("#main-nav").animate({
        left: "-100%"
    }, 500)
    $(overlay_bg).fadeOut(500)
    $("body").css("overflow", "");
    $("html").css("overflow", "")
}